var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Lynx-Title',{attrs:{"text":"Upload de Certidão Negativa de Débitos"}}),(_vm.loading)?_c('Lynx-OverlaySpinner',{attrs:{"loading":_vm.loading}}):_vm._e(),_c('DragAndDropInput',{attrs:{"uploadSuccess":_vm.uploadSuccess},on:{"upload":_vm.upload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }